import Reveal from "../../../shared/design/Reveal";
import GuestImg from "../../../assets/home-aboutus-3.jpg";

const Testimonial = () => {
  return (
    <Reveal className="mx-auto max-w-[1000px] px-6 py-20 text-center md:px-12">
      <div className="h-[30px] font-serif text-[60px] leading-none text-primary-500">
        “
      </div>
      <p className="mb-7 font-serif text-[26px] font-normal leading-[1.35] tracking-[-0.01em] md:text-[32px]">
        Ten days in the Rockies and I came home a different person. The guides
        knew every ridge, every story. Wander didn't sell me a trip — they
        handed me a memory.
      </p>
      <div className="flex items-center justify-center gap-3.5">
        <img
          src={GuestImg}
          alt="Maya Ellison"
          className="h-[46px] w-[46px] rounded-full object-cover"
        />
        <div className="text-left">
          <div className="text-[14.5px] font-bold">Maya Ellison</div>
          <div className="text-[13px] text-muted-300">
            Canadian Rockies Traverse · 2025
          </div>
        </div>
      </div>
    </Reveal>
  );
};

export default Testimonial;
